<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Allgemeine Geschäftsbedingungen (AGB)</h3>
        <!--
        <h5 class="description list">
          AutoEdge 24 - Inhaber: Andreas Leibolt<br>
          Grüsener Str. 17a<br>
          35285 Gemünden<br>
          Telefon: +49 176 55980480<br>
          E-Mail: kontakt@autoedge24.de<br>
          Internet: www.autoedge24.de
        </h5>
        -->
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 1 Geltungsbereich</h4>
            <h5 class="description list">
              (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und sonstigen Leistungen zwischen AutoEdge 24 - Inhaber Andreas Leibolt (nachfolgend „Verkäufer“) und dem Kunden in der zum Zeitpunkt des Vertragsschlusses gültigen Fassung.<br>
              (2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Verkäufer stimmt deren Geltung ausdrücklich schriftlich zu.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 2 Vertragsschluss</h4>
            <h5 class="description list">
              (1) Die Darstellung der Produkte auf der Website oder in Angeboten stellt kein rechtlich bindendes Angebot, sondern eine Aufforderung zur Bestellung dar.<br>
              (2) Durch die Bestellung der gewünschten Ware gibt der Kunde ein verbindliches Angebot auf Abschluss eines Kaufvertrages ab.<br>
              (3) Der Vertrag kommt erst durch ausdrückliche Bestätigung oder durch Auslieferung der Ware zustande.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 3 Preise und Zahlungsbedingungen</h4>
            <h5 class="description list">
              (1) Alle Preise sind Endpreise in Euro. Gemäß § 19 UStG wird keine Umsatzsteuer berechnet und ausgewiesen.<br>
              (2) Versandkosten werden gesondert ausgewiesen.<br>
              (3) Der Kaufpreis ist sofort fällig, sofern keine abweichende Zahlungsfrist vereinbart<br>
              (4) Akzeptierte Zahlungsmethoden werden im Bestellprozess angegeben.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 4 Lieferung und Versand</h4>
            <h5 class="description list">
              (1) Der Versand erfolgt an die vom Kunden angegebene Lieferadresse.<br>
              (2) Liefertermine sind nur verbindlich, wenn sie schriftlich bestätigt wurden.<br>
              (3) Der Verkäufer ist zu Teillieferungen berechtigt, sofern dies dem Kunden zumutbar ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 5 Eigentumsvorbehalt</h4>
            <h5 class="description list">
              Die gelieferte Ware bleibt bis zur vollständigen Bezahlung Eigentum des Verkäufers.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 6 Gewährleistung</h4>
            <h5 class="description list">
              Es gelten die gesetzlichen Gewährleistungsrechte. Bei gebrauchten Waren beträgt die Gewährleistungsfrist 1 Jahr ab Lieferung, sofern der Kunde Unternehmer ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 7 Haftung</h4>
            <h5 class="description list">
              (1) Der Verkäufer haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit.<br>
              (2) Bei leichter Fahrlässigkeit haftet der Verkäufer nur für Schäden aus der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), jedoch begrenzt auf den vorhersehbaren, vertragstypischen Schaden.<br>
              (3) Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 8 Widerrufsrecht für Verbraucher</h4>
            <h5 class="description list">
              <b>(1) Widerrufsrecht</b>
                  <span class="tab-1">Verbraucher haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</span>
                  <br>
              <b>(2) Fristbeginn</b>
                  <span class="tab-1">Die Widerrufsfrist beträgt 14 Tage ab dem Tag,</span>
                  <span class="tab-2">•	an dem der Verbraucher oder ein von ihm benannter Dritter, der nicht der Beförderer ist, die Ware in Besitz genommen hat, oder</span>
                  <span class="tab-2">•	im Falle mehrerer Waren, die getrennt geliefert werden, ab dem Tag, an dem die letzte Ware in Besitz genommen wurde.</span>
                  <br>
              <b>(3) Ausübung des Widerrufs</b>
                  <span class="tab-1">Um das Widerrufsrecht auszuüben, muss der Verbraucher den Verkäufer</span>
                  <br>
                  <span class="tab-1">AutoEdge24</span>
                  <span class="tab-1">Grüsener Straße 17a</span>
                  <span class="tab-1">35285 Gemünden (Wohra)</span>
                  <span class="tab-1">E-Mail: kontakt@autoedge24.de</span>
                  <br>
                  <span class="tab-1">mittels einer eindeutigen Erklärung (z. B. per Brief oder E-Mail) über seinen Entschluss informieren, diesen Vertrag zu widerrufen. Zur Wahrung der Widerrufsfrist reicht es aus, dass die Mitteilung über den Widerruf vor Ablauf der Widerrufsfrist abgesendet wird.</span>
                  <br>
              <b>(4) Folgen des Widerrufs</b>
                  <span class="tab-1">Wenn der Verbraucher diesen Vertrag widerruft, hat der Verkäufer alle Zahlungen, die er erhalten hat, einschließlich der Lieferkosten (mit Ausnahme zusätzlicher Kosten, die daraus entstehen, dass der Verbraucher eine andere Art der Lieferung als die vom Verkäufer angebotene, günstigste Standardlieferung gewählt hat), unverzüglich und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über den Widerruf eingegangen ist.</span>
                  <span class="tab-1">Für die Rückzahlung verwendet der Verkäufer dasselbe Zahlungsmittel, das der Verbraucher eingesetzt hat, es sei denn, es wurde ausdrücklich etwas anderes vereinbart. Der Verkäufer kann die Rückzahlung verweigern, bis er die Ware zurückerhalten hat oder der Verbraucher den Nachweis erbracht hat, dass er die Ware zurückgesendet hat - je nachdem, welches der frühere Zeitpunkt ist.</span>
                  <br>
              <b>(5) Rücksendung der Ware / Einlagerungsgebühr</b>
                  <span class="tab-1">Der Verbraucher hat die Ware unverzüglich und spätestens binnen 14 Tagen ab dem Tag der Widerrufserklärung an den Verkäufer zurückzusenden oder zu übergeben.</span>
                  <span class="tab-1">Die Frist ist gewahrt, wenn die Ware vor Ablauf der 14 Tage abgesendet wurde.</span>
                  <span class="tab-1">Der Verbraucher trägt die unmittelbaren Kosten der Rücksendung der Ware, sofern nichts anderes vereinbart wurde.</span>
                  <span class="tab-1">Der Verbraucher haftet für einen etwaigen Wertverlust der Ware nur, wenn dieser Wertverlust auf einen Umgang zurückzuführen ist, der zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Ware nicht notwendig war.</span>
                  <span class="tab-1">Bei Ausübung des Widerrufs berechnet der Verkäufer eine Einlagerungsgebühr in Höhe von 10 % des Warenwertes für die Dauer der gesetzlichen Rückgabefrist von 14 Tagen.</span>
                  <br>
              <b>Muster-Widerrufsformular</b>

              <span class="tab-1">Wenn Sie den Vertrag widerrufen möchten, füllen Sie bitte dieses Formular aus und senden Sie es zurück an:</span>

              <br>
              <span class="tab-1">AutoEdge24</span>
              <span class="tab-1">Grüsener Straße 17a</span>
              <span class="tab-1">35285 Gemünden (Wohra)</span>
              <span class="tab-1">E-Mail: kontakt@autoedge24.de</span>
              <br>

              <span class="tab-1">Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über den Kauf folgender Ware(n):</span>
              <span class="tab-1">- Bestellt am / erhalten am: __________</span>
              <span class="tab-1">- Name des/der Verbraucher(s): __________</span>
              <span class="tab-1">- Anschrift des/der Verbraucher(s): ________</span>
              <br>
              <span class="tab-1">Ort, Datum & Unterschrift (nur bei Papiermitteilung)</span>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 9 Datenschutz</h4>
            <h5 class="description list">
              Der Verkäufer verarbeitet personenbezogene Daten des Kunden nur gemäß der Datenschutzerklärung, die Bestandteil dieser AGB ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 10 Streitbeilegung</h4>
            <h5 class="description list">
              Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a><br>
              Der Verkäufer ist weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 11 Schlussbestimmungen</h4>
            <h5 class="description list">
              (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.<br>
              (2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Gültigkeit der übrigen Bestimmungen unberührt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Hinweis zum Haftungsausschluss bei Ersatzteilen</h4>
            <h5 class="description list">
              Die gelieferten Ersatzteile dürfen nur durch qualifiziertes Fachpersonal eingebaut werden. Der Einbau erfolgt auf eigene Verantwortung.
              AutoEdge 24 übernimmt keine Haftung für Schäden, die durch unsachgemäße Montage oder Verwendung entstehen.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'terms',
  bodyClass: 'terms-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 70px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}
.tab-0 {
  display: block;
}
.tab-1 {
  margin-left: 20px;
  display: block;
}
.tab-2 {
  margin-left: 40px;
  display: block;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
